import { render, staticRenderFns } from "./database.vue?vue&type=template&id=66e18d9e&scoped=true&lang=pug"
import script from "./database.vue?vue&type=script&lang=js"
export * from "./database.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e18d9e",
  null
  
)

/* custom blocks */
import block0 from "./database.vue?vue&type=custom&index=0&blockType=router"
if (typeof block0 === 'function') block0(component)

export default component.exports